import React, { useEffect } from 'react';
import { Page } from '@components/page';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { Header } from './components/header';
import { Body } from './components/body';
import { fetchItems } from '@redux/slices/item';
import { CardTable } from '@components/table/styled';
import { Col } from 'antd';
import { translate } from '@components/i18n';
import { fetchDivisions } from '@redux/slices/divisions';
import { fetchAllAvailablePlatforms } from '@redux/slices/order';

export const Item: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchItems({ current: 1, pageSize: 10 }));
        dispatch(fetchDivisions());
        dispatch(fetchAllAvailablePlatforms());
    }, []);

    return (
        <Page
            title={translate('pages.items')}
            greyBackground
            onClickGoBack
            menuIcon={<LeftOutlined />}
        >
            <Col span={22} style={{ alignSelf: 'center' }}>
                <h2 style={{ marginTop: '15px' }}>
                    {translate('titlePages.items')}
                </h2>
                <CardTable>
                    <Header />
                    <Body />
                </CardTable>
            </Col>
        </Page>
    );
};
